'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMaskCount = exports.initialState = undefined;

var _ToggleMaskAction = require('./actions/ToggleMaskAction');

var _HideDialogAction = require('../../components/dialog/actions/HideDialogAction');

var _ShowDialogAction = require('../../components/dialog/actions/ShowDialogAction');

var _immutable = require('immutable');

var initialState = exports.initialState = (0, _immutable.Map)({
  maskCount: 0
});

var getMaskCount = exports.getMaskCount = function getMaskCount(state) {
  return state.get('maskCount');
};

var incrementMaskCount = function incrementMaskCount(state) {
  return getMaskCount(state) + 1;
};

var decrementMaskCount = function decrementMaskCount(state) {
  var maskCount = getMaskCount(state) - 1;
  return maskCount < 0 ? 0 : maskCount;
};

var maskReducer = function maskReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {
    case _ToggleMaskAction.TOGGLE_MASK_ACTION:
      {
        return state.set("maskCount", action.showMask ? incrementMaskCount(state) : decrementMaskCount(state));
      }
    case _ShowDialogAction.SHOW_DIALOG_ACTION:
      {
        return state.set("maskCount", incrementMaskCount(state));
      }
    case _HideDialogAction.HIDE_DIALOG_ACTION:
      {
        return state.set("maskCount", decrementMaskCount(state));
      }
    default:
      {
        return state;
      }
  }
};

exports.default = maskReducer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/mask/MaskReducer.js
// module id = 143
// module chunks = 10